"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.deepCopyMatrix = exports.RiskTargetUtils = exports.getPercentileId = exports.getConsequenceId = exports.getFrequencyId = exports.ConsequencePercentiles = exports.displayFrequency = exports.FrequencyDisplayChoices = exports.displayConsequence = exports.ConsequenceDisplayChoices = exports.CellChoices = exports.MATRIX_MAX_SIZE = void 0;
exports.MATRIX_MAX_SIZE = 8;
var CellChoices = (function () {
    function CellChoices() {
    }
    CellChoices.getColorDisplay = function (color) {
        switch (color) {
            case CellChoices.LOW:
                return CellChoices.COLOR_CLASSES.LOW;
            case CellChoices.MID_LOW:
                return CellChoices.COLOR_CLASSES.MID_LOW;
            case CellChoices.MID_HIGH:
                return CellChoices.COLOR_CLASSES.MID_HIGH;
            case CellChoices.HIGH:
                return CellChoices.COLOR_CLASSES.HIGH;
            default:
                return "";
        }
    };
    CellChoices.asChoices = function () {
        return [
            {
                display_name: CellChoices.LABELS.LOW,
                value: CellChoices.LOW.toString(),
                htmlClass: CellChoices.COLOR_CLASSES.LOW,
            },
            {
                display_name: CellChoices.LABELS.MID_LOW,
                value: CellChoices.MID_LOW.toString(),
                htmlClass: CellChoices.COLOR_CLASSES.MID_LOW,
            },
            {
                display_name: CellChoices.LABELS.MID_HIGH,
                value: CellChoices.MID_HIGH.toString(),
                htmlClass: CellChoices.COLOR_CLASSES.MID_HIGH,
            },
            {
                display_name: CellChoices.LABELS.HIGH,
                value: CellChoices.HIGH.toString(),
                htmlClass: CellChoices.COLOR_CLASSES.HIGH,
            },
        ];
    };
    CellChoices.LOW = 0;
    CellChoices.MID_LOW = 10;
    CellChoices.MID_HIGH = 20;
    CellChoices.HIGH = 30;
    CellChoices.LABELS = {
        LOW: gettext("Low"),
        MID_LOW: gettext("Mid-low"),
        MID_HIGH: gettext("Mid-high"),
        HIGH: gettext("High"),
    };
    CellChoices.COLOR_CLASSES = {
        LOW: "cell_low",
        MID_LOW: "cell_mid_low",
        MID_HIGH: "cell_mid_high",
        HIGH: "cell_high",
    };
    CellChoices.RISK_COLORS = {
        LOW: "#3AA551",
        MID_LOW: "#FCFE04",
        MID_HIGH: "#FC6604",
        HIGH: "#C63418",
    };
    CellChoices.OPPORTUNITY_COLORS = {
        LOW: "#D9EFFF",
        MID_LOW: "#ADDDFF",
        MID_HIGH: "#5CA3CA",
        HIGH: "#006FAD",
    };
    return CellChoices;
}());
exports.CellChoices = CellChoices;
var ConsequenceDisplayChoices = (function () {
    function ConsequenceDisplayChoices() {
    }
    ConsequenceDisplayChoices.asChoices = function (percentiles) {
        var options = [
            {
                display_name: gettext("Description"),
                value: ConsequenceDisplayChoices.DESCRIPTION.toString(),
            },
            {
                display_name: gettext("Absolute values"),
                value: ConsequenceDisplayChoices.ABSOLUTE.toString(),
            },
        ];
        if (percentiles) {
            options.push({
                display_name: gettext("Percentiles"),
                value: ConsequenceDisplayChoices.PERCENTILES.toString(),
            });
        }
        return options;
    };
    ConsequenceDisplayChoices.DESCRIPTION = 10;
    ConsequenceDisplayChoices.PERCENTILES = 20;
    ConsequenceDisplayChoices.ABSOLUTE = 30;
    return ConsequenceDisplayChoices;
}());
exports.ConsequenceDisplayChoices = ConsequenceDisplayChoices;
function displayConsequence(cons, display) {
    if (display == ConsequenceDisplayChoices.DESCRIPTION) {
        return cons.description;
    }
    else if (display == ConsequenceDisplayChoices.PERCENTILES) {
        return "".concat(cons.percentile_low, " - ").concat(cons.percentile_high);
    }
    else if (display == ConsequenceDisplayChoices.ABSOLUTE) {
        return "".concat(cons.low, " - ").concat(cons.high);
    }
}
exports.displayConsequence = displayConsequence;
var FrequencyDisplayChoices = (function () {
    function FrequencyDisplayChoices() {
    }
    FrequencyDisplayChoices.asChoices = function () {
        return [
            {
                display_name: gettext("Description"),
                value: FrequencyDisplayChoices.DESCRIPTION.toString(),
            },
            {
                display_name: gettext("Absolute values"),
                value: FrequencyDisplayChoices.ABSOLUTE.toString(),
            },
        ];
    };
    FrequencyDisplayChoices.DESCRIPTION = 10;
    FrequencyDisplayChoices.ABSOLUTE = 20;
    return FrequencyDisplayChoices;
}());
exports.FrequencyDisplayChoices = FrequencyDisplayChoices;
function displayFrequency(freq, display) {
    if (display == FrequencyDisplayChoices.DESCRIPTION) {
        return freq.description;
    }
    else if (display == FrequencyDisplayChoices.ABSOLUTE) {
        return "".concat(freq.low, " - ").concat(freq.high);
    }
}
exports.displayFrequency = displayFrequency;
var ConsequencePercentiles = (function () {
    function ConsequencePercentiles() {
    }
    ConsequencePercentiles.LOW = "P(10)";
    ConsequencePercentiles.MID = "P(50)";
    ConsequencePercentiles.HIGH = "P(90)";
    return ConsequencePercentiles;
}());
exports.ConsequencePercentiles = ConsequencePercentiles;
function getFrequencyId(freq, level) {
    return "freq_".concat(freq.id, "_").concat(level);
}
exports.getFrequencyId = getFrequencyId;
function getConsequenceId(cons, level) {
    return "cons_".concat(cons.id, "_").concat(level);
}
exports.getConsequenceId = getConsequenceId;
function getPercentileId(cons, level) {
    return "perc_".concat(cons.id, "_").concat(level);
}
exports.getPercentileId = getPercentileId;
var RiskTargetUtils = (function () {
    function RiskTargetUtils() {
    }
    RiskTargetUtils.getRiskMatrix = function (target) {
        return target.matrices.filter(function (m) { return m.is_opportunity == false; })[0];
    };
    RiskTargetUtils.getOpportunityMatrix = function (target) {
        return target.matrices.filter(function (m) { return m.is_opportunity; })[0];
    };
    return RiskTargetUtils;
}());
exports.RiskTargetUtils = RiskTargetUtils;
function deepCopyMatrix(matrix) {
    var newMatrix = __assign({}, matrix);
    newMatrix.frequencies = matrix.frequencies.map(function (freq) { return (__assign({}, freq)); });
    newMatrix.consequences = matrix.consequences.map(function (cons) { return (__assign({}, cons)); });
    newMatrix.cells = matrix.cells.map(function (cell) { return (__assign({}, cell)); });
    return newMatrix;
}
exports.deepCopyMatrix = deepCopyMatrix;
